module.exports = "<button type=\"button\" class=\"btn btn-dark btn-lg btn-block rounded-0 border-0 text-left d-flex flex-row pr-0 mr-0 pl-1 pb-0 pt-0\" (click)='openLink()'>\n  <div class=\"usefullink-item-container d-flex flex-column text-truncate\">\n    <span class=\"p-0 mb-0 font-weight-light\" [ngClass]=\"{'font-weight-bold': usefulLink.priority}\">{{usefulLink.displayName}}</span>\n  </div>\n</button>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/useful-link-item/useful-link-item.component.html
// module id = ./src/app/shared/components/useful-link-item/useful-link-item.component.html
// module chunks = main